import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(callback) {
    const media = window.matchMedia(QUERY);
    media.addEventListener("change", callback);
    return () => media.removeEventListener("change", callback);
}

// Vrai quand le visiteur a demandé moins d'animations. Sert aux animations que
// le CSS ne peut pas couper lui-même (SMIL, animations pilotées en JavaScript).
export default function usePrefersReducedMotion() {
    return useSyncExternalStore(
        subscribe,
        () => window.matchMedia(QUERY).matches,
        () => false,
    );
}
